export default __webpack_public_path__ + "static/tech-c4166811c9bd49c732d63f5bd15cefc9.jpg";